/// <amd-module name="Artifacts/Sample/components/SampleComponent" />

import { connectDynamicModules } from "Artifacts/Root/Redux";
import {
  ISampleReduxState,
  SampleActions,
  SampleActionTypes,
  SampleReduxModule,
} from "Artifacts/Sample/redux";
import * as React from "react";
import { connect } from "react-redux";
import { Action } from "redux/Utils/ActionHelper";
import { Components } from "VSS/Platform/Layout";

const Actions = {
  doHelloWorld: SampleActions.helloWorld,
};

const mapStateToProps = (state: ISampleReduxState) => {
  return {
    hello: state.simpleState.hello,
  };
};

interface ISampleComponentProps {
  hello: string;
  doHelloWorld: () => Action<SampleActionTypes>;
}

const SampleComponent: React.FC<ISampleComponentProps> = ({ hello, doHelloWorld }) => {
  return (
    <div className="sample flex-column">
      <span>Hello world: {hello}</span>
      <button onClick={doHelloWorld}>Say hello world</button>
    </div>
  );
};

const ConnectedSampleComponent = connectDynamicModules(
  connect(mapStateToProps, Actions)(SampleComponent),
  SampleReduxModule,
);

Components.add("ms.azure-artifacts.artifacts-sample", SampleComponent);

export { ConnectedSampleComponent as SampleComponent };
